const MAX_RESULTS = 5;

let pagefind = null;
let currentSelection = -1;
let currentResults = [];

function getModal() {
  return document.getElementById('search-modal');
}

function createModal() {
  const el = document.createElement('div');
  el.id = 'search-modal';
  el.className = 'search-modal';
  el.setAttribute('hidden', '');
  el.setAttribute('role', 'dialog');
  el.setAttribute('aria-modal', 'true');
  el.setAttribute('aria-label', 'Recherche');
  el.innerHTML = `
    <div class="search-modal__backdrop"></div>
    <div class="search-modal__box">
      <div class="search-modal__input-row">
        <input class="search-modal__input" type="search" placeholder="Rechercher…" autocomplete="off" spellcheck="false">
      </div>
      <div class="search-modal__results"></div>
    </div>
  `;
  document.body.appendChild(el);
}

async function loadPagefind() {
  if (pagefind) {
    return;
  }
  try {
    pagefind = await import(/* webpackIgnore: true */ '/pagefind/pagefind.js');
  } catch {
    // Pagefind unavailable in dev mode
  }
}

function openModal() {
  const modal = getModal();
  if (!modal) {
    return;
  }
  modal.removeAttribute('hidden');
  document.body.style.overflow = 'hidden';
  modal.querySelector('.search-modal__input').focus();
  loadPagefind();
}

function closeModal() {
  const modal = getModal();
  if (!modal) {
    return;
  }
  modal.setAttribute('hidden', '');
  document.body.style.overflow = '';
  modal.querySelector('.search-modal__input').value = '';
  modal.querySelector('.search-modal__results').innerHTML = '';
  currentSelection = -1;
  currentResults = [];
}

function renderResults(results, hasSearched = true) {
  const container = getModal().querySelector('.search-modal__results');

  if (!hasSearched) {
    container.innerHTML = '';
    return;
  }

  if (!results.length) {
    container.innerHTML = '<p class="search-no-results">Aucun résultat</p>';
    return;
  }

  container.innerHTML = results
    .map(
      (r, i) => `
    <a class="search-result${i === currentSelection ? ' is-selected' : ''}" href="${r.url}" data-index="${i}">
      ${r.meta?.image ? `<img class="search-result__image" src="${r.meta.image}" alt="" loading="lazy">` : ''}
      <div class="search-result__content">
        <div class="search-result__title">${r.meta?.title ?? 'Sans titre'}</div>
        <div class="search-result__excerpt">${r.excerpt}</div>
      </div>
    </a>
  `
    )
    .join('');
}

async function performSearch(query) {
  if (!pagefind) {
    return;
  }

  if (!query.trim()) {
    currentResults = [];
    renderResults([], false);
    return;
  }

  const response = await pagefind.debouncedSearch(query);
  if (!response) {
    return;
  }

  const data = await Promise.all(response.results.slice(0, MAX_RESULTS).map((r) => r.data()));
  currentResults = data;
  currentSelection = -1;
  renderResults(data);
}

function moveSelection(dir) {
  if (!currentResults.length) {
    return;
  }
  const len = currentResults.length;
  currentSelection = (currentSelection + dir + len) % len;
  renderResults(currentResults);
  getModal().querySelector('.search-result.is-selected')?.scrollIntoView({ block: 'nearest' });
}

function initSearch() {
  createModal();

  const modal = getModal();
  const trigger = document.querySelector('.header-search-trigger');

  trigger?.addEventListener('click', openModal);

  modal.querySelector('.search-modal__backdrop').addEventListener('click', closeModal);

  modal.querySelector('.search-modal__input').addEventListener('input', (e) => {
    performSearch(e.target.value);
  });

  modal.querySelector('.search-modal__results').addEventListener('mouseover', (e) => {
    const result = e.target.closest('.search-result');
    if (!result) {
      return;
    }
    const idx = parseInt(result.dataset.index, 10);
    if (idx !== currentSelection) {
      modal.querySelector('.search-result.is-selected')?.classList.remove('is-selected');
      result.classList.add('is-selected');
      currentSelection = idx;
    }
  });

  document.addEventListener('keydown', (e) => {
    const isOpen = !modal.hasAttribute('hidden');

    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      isOpen ? closeModal() : openModal();
      return;
    }

    if (!isOpen) {
      return;
    }

    switch (e.key) {
      case 'Escape':
        closeModal();
        break;
      case 'ArrowDown':
        e.preventDefault();
        moveSelection(1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        moveSelection(-1);
        break;
      case 'Enter':
        if (currentSelection >= 0 && currentResults[currentSelection]) {
          window.location.href = currentResults[currentSelection].url;
        }
        break;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearch);
} else {
  initSearch();
}
